<div class="container-custom">
  <div class="row align-items-center justify-content-center">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" autocomplete="off" novalidate>
      <div class="card" style="width: 21rem;">
        <div class="card-header">{{'ACTIVATION.CONTINGENCY_ACTIVATION' | translate}}</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label [innerHTML]="'ACTIVATION.REQUEST_ID'| translate"></label>
              <input type="number" name="requestId" #requestId="ngModel" [(ngModel)]="activation.requestId" class="form-control w-100" id="requestId" required ng-model="activation.requestId">
              <div class="spacer-custom-100"></div>
            </div>
            <div class="col-md-12">
              <label [innerHTML]="'ACTIVATION.DATE_TIME'| translate"></label>
              <input type="datetime-local" name="date" #requestId="ngModel" [(ngModel)]="activation.date" class="form-control w-100" step=1 ng-model="activation.date" required />
              <div class="spacer-custom-100"></div>
            </div>
            <div class="col-md-12">
              <label [innerHTML]="'ACTIVATION.VALID_FOR'| translate"></label>
              <select required name="validFor" #refvalidFor="ngModel" [(ngModel)]="selectedValidFor" class="form-control w-100" [disabled]="isDisabled">
                  <option disabled>{{'COM.SELECT_VALUE' | translate}}</option>
                  <option [ngValue]="0">{{'ACTIVATION.ACTIVATION_TEST' | translate}}</option>
                  <option *ngFor="let valid of validList | slice:1" [ngValue]="valid.id">{{valid.name}}</option>
              </select>
            </div>
            <input type="hidden" name="logUser" #logUser="ngModel" [(ngModel)]="activation.logUser" class="form-control" id="logUser" ng-model="activation.logUser">
          </div>

          <div *ngIf="respReq">
            <div class="spacer-custom-100"></div>
            <div class="spacer-line-custom"></div>
            <div class="text-center">
              <div style="width: 100%; height: 1rem;"></div>
              <div *ngIf="!error" class="alert alert-custom alert-green-custom text-center fade show w-100" style="margin: auto;" role="alert">
                <label>{{'ACTIVATION.GENERATED_ACTIVATION_CODE' | translate}}: </label>
                <h2>{{resCode}}</h2>
              </div>
              <div *ngIf="error" class="alert alert-custom alert-red-custom text-center fade show" role="alert">
                <h6>{{resError}}</h6>
              </div>
            </div>
          </div>


            <div class="spacer-custom-100"></div>
            <div class="spacer-line-custom"></div>
            <div class="spacer-custom-100"></div>
            <div class="spacer-custom-100"></div>
            <div class="spacer-custom-100"></div>
            <div class="text-center">
              <button class="btn btn-custom" style="min-width: 100px" type="submit" [disabled]="form.invalid">{{'ACTIVATION.GENERATE_CODE' | translate}} </button>
              &nbsp;
              <button class="btn btn-outline-custom" type="button" (click)="resetForm(form)">{{'ACTIVATION.CANCEL' | translate}} </button>
            </div>
          </div>
      </div>
    </form>
  </div>
</div>
